<template>
    <div class="management_container">
        <HeaderSivoaVue />

        <div class="management_background_image">
            <div class="" style="margin-top: 25px; margin-bottom: 260px;">
                <img src="./images/Common/deconnexion.svg" style="cursor: pointer;" alt="deconnexion" height="20px" width="98px" v-on:click="logout()" />
            </div>

            <div class="w3-row-padding w3-stretch">
                <div class="w3-third w3-container w3-margin-bottom">
                    <div class="management_menu1">
                        <div class="management_menu_title1">&Eacute;COLE &Eacute;L&Eacute;MENTAIRE</div>
                        <div class="management_menu_title2">ATELIERS</div>
                        <div style="height: 81px;"></div>
                        <div class="w3-center management_menu_button_title">ATELIERS CYCLE 2 (CP - CE1 - CE2)</div>
                        <a v-bind:href="ws2_url">
                            <div class="w3-center management_menu_button management_menu_button_text1">T&Eacute;L&Eacute;CHARGER</div>
                        </a>
                    </div>
                </div>
                <div class="w3-third w3-container w3-margin-bottom">
                    <div class="management_menu2">
                        <div class="management_menu_title1">&Eacute;COLE &Eacute;L&Eacute;MENTAIRE</div>
                        <div class="management_menu_title2">ATELIERS</div>
                        <div style="height: 81px;"></div>
                        <div class="w3-center management_menu_button_title">ATELIERS CYCLE 3 (CM1 - CM2)</div>
                        <a v-bind:href="ws3_url">
                            <div class="w3-center management_menu_button management_menu_button_text2">T&Eacute;L&Eacute;CHARGER</div>
                        </a>
                    </div>
                </div>
                <div class="w3-third w3-container w3-margin-bottom">
                    <div class="management_menu3">
                        <div class="management_menu_title1">COLL&Egrave;GE</div>
                        <div class="management_menu_title2">MODULE</div>
                        <div style="height: 81px;"></div>
                        <div class="w3-center management_menu_button_title">MODULE COLL&Egrave;GE</div>
                        <a v-bind:href="mc_url">
                            <div class="w3-center management_menu_button management_menu_button_text3">T&Eacute;L&Eacute;CHARGER</div>
                        </a>
                    </div>
                </div>

            </div>

        </div>

        <div style="height: 32px;"></div>

        <FooterSivoaVue />
    </div>
</template>

<script>
    import HeaderSivoaVue from './HeaderSivoa.vue';
    import FooterSivoaVue from './FooterSivoa.vue';

    export default {
        name: 'management_vue',
        data() {
            return {
                debug: 0,
                xls_to_download_url: '',
            }
        },
        components: {
            HeaderSivoaVue,
            FooterSivoaVue
        },
        methods: {
            logout() {
                this.$store.commit("setAuthentication", { status: false, token: '' });
                this.$router.replace({ name: "home" });
            },
        },
        computed: {
            ws2_url() {
                return 'php/exportxls_ws.php?year=2024&cycle=2' + '&token=' + this.$store.state.token;
            },
            ws3_url() {
                return 'php/exportxls_ws.php?year=2024&cycle=3' + '&token=' + this.$store.state.token;
            },
            mc_url() {
                return 'php/exportxls_mc.php?year=2024' + '&token=' + this.$store.state.token;
            },
        },

    };

</script>

<style scoped>
    a {
        text-decoration: none;
    }

    .management_container {
        padding-left: 37px;
        padding-right: 37px;
    }

    .management_background_image {
        width: 100%;
        height: auto;
        background-image: url('./images/Home/bulle.png');
        background-size: cover;
        background-repeat: no-repeat;
        background-color: #C5DCF3;
        padding-left: 37px;
        padding-right: 37px;
    }

    .management_menu1 {
        padding: 20px;
        background: #0A71B3;
        background: rgba(10, 113, 179, 1);
        border-radius: 30px;
        -moz-border-radius: 30px;
        -webkit-border-radius: 30px;
    }

    .management_menu2 {
        padding: 20px;
        background: #97BF0D;
        background: rgba(151, 191, 13, 1);
        border-radius: 30px;
        -moz-border-radius: 30px;
        -webkit-border-radius: 30px;
    }

    .management_menu3 {
        padding: 20px;
        background: #EC7404;
        background: rgba(236, 116, 4, 1);
        border-radius: 30px;
        -moz-border-radius: 30px;
        -webkit-border-radius: 30px;
    }

    .management_menu_title1 {
        font-family: 'Quicksand', sans-serif;
        font-size: 20px;
        text-transform: uppercase;
        color: #FFFFFF;
        color: rgb(255, 255, 255);
    }

    .management_menu_title2 {
        font-family: 'Quicksand', sans-serif;
        font-weight: bold;
        font-size: 38px;
        letter-spacing: 0.38px;
        color: #FFFFFF;
        color: rgb(255, 255, 255);
        padding-bottom: 20px;
    }

    .management_menu_button_title {
        font-family: Arial;
        font-weight: bold;
        font-size: 15px;
        text-transform: uppercase;
        color: #FFFFFF;
        color: rgb(255, 255, 255);
    }

    .management_menu_button {
        background: #FFFFFF;
        background: rgba(255, 255, 255, 1);
        border-radius: 10px;
        -moz-border-radius: 10px;
        -webkit-border-radius: 10px;
        font-family: 'Roboto Condensed', sans-serif;
        font-size: 17px;
        line-height: 22.78px;
        text-transform: uppercase;
        padding-top: 8px;
        padding-bottom: 8px;
    }

    .management_menu_button_text1 {
        color: #0A71B3;
        color: rgb(10, 113, 179);
    }

    .management_menu_button_text2 {
        color: #97BF0D;
        color: rgba(151, 191, 13, 1);
    }

    .management_menu_button_text3 {
        color: #EC7404;
        color: rgba(236, 116, 4, 1);
    }
</style>